/* SS: open the Shop list automatically when the mobile menu opens */
(function () {
  function openShop() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    var li = document.querySelector('#wt-drawer-nav .wt-page-nav-mega__item--parent');
    if (!li || li.classList.contains('dropdown-opened') || li.dataset.ssAutoOpened) return;
    var a = li.querySelector(':scope > a');
    li.dataset.ssAutoOpened = '1';
    if (a) a.click();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.wt-header__menu-trigger')) setTimeout(openShop, 30);
  }, true);
})();

/* SS: product gallery videos play on their own when swiped into view, pause when swiped away */
(function () {
  function init() {
    var vids = document.querySelectorAll('.ssp__slide video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = true; });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.5) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
